var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.json_to_download != null)?_c('div',[_vm._v(" Download "),_c('a',{staticClass:"ml-1",attrs:{"href":"#","title":"Download JSON"},on:{"click":function($event){return _vm.downloadJson($event)}}},[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v(" mdi-download ")])],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }